module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.e79bfd88.e79bfd8.eot";


//////////////////
// WEBPACK FOOTER
// ./~/geetest-ui/fonts/MaterialIcons-Regular.e79bfd88.eot
// module id = 463
// module chunks = 14